import { createContext } from 'react'

import { createScanQrcodeStore } from '../store/createStore'

export const ScanQrcodeStoreContext = createContext<
  ReturnType<typeof createScanQrcodeStore> | undefined
>(undefined)
